import { FC, useEffect, useMemo } from 'react';
import { createSpline } from '../../components/ScanItemViewer/MeshViewer/MeshLoadingHelpers';
import { MetricKeyEnum, useLayerStore } from '../LayerControls/layerStore';
import { FeaturesetValues } from '../../network';
import { useHighlighter } from '../ui/useHighlighter';

type SurfaceSpineSplineProps = {
  featuresetValues: FeaturesetValues | undefined;
};

const surfaceSpineSplineLayerKey = MetricKeyEnum.SurfaceSpine;

export const SurfaceSpineSpline: FC<SurfaceSpineSplineProps> = ({
  featuresetValues,
}) => {
  const { addLayerState, isLayerVisible } = useLayerStore();
  useHighlighter({ layerKey: surfaceSpineSplineLayerKey });

  const result = useMemo(() => {
    try {
      const sagittalDisplayDict = featuresetValues?.sagittal_display_dict;

      if (!sagittalDisplayDict) {
        throw new Error(
          'Sagittal display dict is not defined in surface spine spline'
        );
      }

      const points = sagittalDisplayDict?.surface_spline_spine?.points;

      if (!points) {
        throw new Error('Points are not defined in surface spine spline');
      }

      if (points.length === 0) {
        throw new Error('No points found in surface spine spline');
      }

      const surfaceSplineSpine = createSpline(points);
      return {
        surfaceSplineSpine,
      };
    } catch (error) {
      return null;
    }
  }, [featuresetValues?.sagittal_display_dict]);

  useEffect(() => {
    if (!result) {
      return;
    }

    addLayerState(surfaceSpineSplineLayerKey, {
      key: surfaceSpineSplineLayerKey,
      visible: false,
    });
  }, [addLayerState, result]);

  if (!result) {
    return null;
  }
  const showLayer = isLayerVisible(surfaceSpineSplineLayerKey);

  return (
    <group name={surfaceSpineSplineLayerKey} visible={showLayer}>
      <primitive object={result.surfaceSplineSpine} />
    </group>
  );
};
